import styled from 'styled-components';
import { Button, Forms, LoadingSpinner } from '@experian-uk/corvetteuk-common-ui';

export const Form = styled.form.attrs({
  method: 'post',
})`
  margin-top: 2rem;
`;

export const InputContainer = styled.section`
  ${({ theme }) => theme.media('10', `
    align-items: flex-start;
    display: flex;
  `)}

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }
`;

export const SaveButton = styled(Button)`
  margin: ${({ theme }) => `${theme.base.expSpacingSmall} ${theme.base.expSpacingSmall} ${theme.base.expSpacingSmall} 0`};

  ${({ theme }) => theme.media('10', `
    margin: 0 1rem;
  `)}
`;

export const Select = styled(Forms.Select)`
  background: transparent;
  cursor: pointer;
  border: .0625rem solid ${({ theme }) => theme.colors.borderBlue};
  border-radius: .3125rem;
  font-size: 1rem;
  height: 50px;
  margin-bottom: 1rem;
  padding: 0.5rem;
  position: relative;
  transition: .5s ease-in-out;flex: 2;
  z-index: 2;

  &::-ms-expand {
    display: none;
  }

  ${props => props.theme.media('5', `
    padding: 0.75rem;
  `)}
`;

export const Spinner = styled(LoadingSpinner).attrs({
  size: '2rem',
})``;

export const InlineSpinnerContainer = styled.div`
  margin: .75rem 1rem 0;
`;

export const SpinnerContainer = styled(InputContainer).attrs({
  'aria-busy': 'true',
  'role': 'alert',
})`
  align-items: flex-start;
`;

export const SubmitButton = styled(SaveButton)`
  margin: 0;
`;
